import { sendAnalyticsEvents } from '../analytics';
import type { AnalyticsAPI } from '../config/actions/createActions';
import { toFixedTrunc } from '../utils/beautifyNumber';

/**
 * ChatbotResponseSuccess
 *
 * Trigger: when we send an OA message using a reply token
 * Existing event props should be the same as ChatbotMessageSuccess
 *
 * @param elapsedSecondsWebhook - Time in seconds since webhook was received
 */
export function trackChatbotResponseSuccess(
  { elapsed, locale }: { elapsed: number; locale: string },
  api: AnalyticsAPI,
) {
  sendAnalyticsEvents(api, [
    {
      eventType: 'ChatbotResponseSuccess',
      eventProperties: {
        elapsedSecondsWebhook: toFixedTrunc(elapsed / 1000, 4),
        locale,
      },
    },
  ]);
}

/**
 * ChatbotResponseFailure
 *
 * Trigger: when we send an OA message using a reply token
 * Existing event props should be the same as ChatbotMessageFailure
 *
 * @param elapsedSecondsWebhook - Time in seconds since webhook was received
 */
export function trackChatbotResponseFailure(
  { elapsed, error }: { elapsed: number; error: string },
  api: AnalyticsAPI,
) {
  sendAnalyticsEvents(api, [
    {
      eventType: 'ChatbotResponseFailure',
      eventProperties: {
        elapsedSecondsWebhook: toFixedTrunc(elapsed / 1000, 4),
        error,
      },
    },
  ]);
}
